import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TEST_FILE } from '../../services/api/ApiConstants';
import utilService from '../../services/UtilService';
import LinkAdditionalResource from './LinkAdditionalResource';
import FileAdditionalResource from './FileAdditionalResource';

import ChromeAppAdditionalResource from './ChromeAppAdditionalResource';
import ChromeAppResourceBarHomeButton from './ChromeAppResourceBarHomeButton';

import settingsReader from '../../store/readHelpers/SettingsReader';
import styles from './additionalResourcesBar.scss';
import additionalResourcesService from '../../services/AdditionalResourcesService';
import { t } from '../../services/i18nService';
import constants from '../../qti/Constants';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import RubricAdditionalResource from './RubricAdditionalResource';
import sessionReader from '../../store/readHelpers/SessionReader';

class AdditionalResourcesBar extends React.PureComponent {
    static propTypes = {
        additionalResources: PropTypes.array.isRequired,
        currentlyShownQuestion: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            renderIframe: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                renderIframe: true,
            });
        }, 1000);
    }

    render() {
        const { additionalResources, currentlyShownQuestion } = this.props;
        let resources;

        if (sessionReader.isInsidePwaChromeApp()) {
            resources = additionalResources.map((resource) => {
                return <ChromeAppAdditionalResource resource={resource} key={`${resource.title}_${resource.type}`} />;
            });
            const chromeAppResourcesBarHomeButton = <ChromeAppResourceBarHomeButton key="chromeAppResourceBarHomeButton" />;
            resources.unshift(chromeAppResourcesBarHomeButton);
        } else {
            resources = additionalResources.map((resource) => {
                return resource.type === constants.additionalResourceType.FILE
                    ? <FileAdditionalResource resource={resource} key={`${resource.title}_${resource.contentItemId}`} />
                    : <LinkAdditionalResource resource={resource} key={`${resource.title}_${resource.link}`} />;
            });
        }

        const showRubricForQuestion = settingsReader.isShowRubricForQuestionEnabled();
        if (showRubricForQuestion && currentlyShownQuestion.hasRubricsMarking) {
            resources.push(<RubricAdditionalResource currentlyShownQuestion={currentlyShownQuestion} />);
        }

        const { renderIframe } = this.state;
        const hasResource = resources.length > 0;
        const shouldRenderHiddenIframe = renderIframe && hasResource && settingsReader.isSEBForIOSEnabled() && utilService.isIOS();

        // the empty iFrame below is added as workaround to be able to open additional resources in new window and switch between them for SEB iOS
        return (
            <div className={styles.additionalResourcesBar} id="additionalResBar" role="navigation" aria-label={t('navigation.resourcesTitle')}>
                { hasResource &&
                    <ul>
                        {resources}
                    </ul>
                }

                { shouldRenderHiddenIframe &&
                    <iframe
                        src={TEST_FILE}
                        className={styles.hiddenIframe}
                        title="empty frame for SEB iOS"
                    />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { settings, assessment, parentTest, currentlyShown } = state;
    const currentlyShownQuestion = assessmentReader.getQuestion(currentlyShown.questionId) || {};
    return {
        additionalResources: additionalResourcesService.getAdditionalResources(settings, assessment, parentTest),
        currentlyShownQuestion,
    };
}

const AdditionalResourcesBarContainer = connect(mapStateToProps)(AdditionalResourcesBar);
export default AdditionalResourcesBarContainer;
